import { View } from "react-native";
import IonIcons from "react-native-vector-icons/Ionicons";
import { TranslateText } from "./translate-text";

type HeaderProps = {
    heading: string,
    goBack: () => void,
}

export const Header = ({heading, goBack}: HeaderProps) => {
    return (
        <View
        style={{
          position: "absolute",
          top: 0,
          width: "100%",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          paddingVertical: 12,
          paddingHorizontal: 12,
          zIndex: 999999,
          shadowColor: "#000",
          shadowRadius: 20,
          shadowOpacity: 0.2,
        }}
      >
        <IonIcons
          name="arrow-back"
          size={20}
          color={"#000"}
          onPress={goBack}
        />
        <TranslateText style={{ fontSize: 20 }}>{heading}</TranslateText>
        <TranslateText style={{ fontSize: 20 }}></TranslateText>
      </View>
    )
}